import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { OverlayPanel } from 'primeng/overlaypanel';
import { map } from 'rxjs/operators';
import { ConfirmacaoService } from 'src/app/core/confirmacao/confirmacao.service';
import { DefaultFilter } from 'src/app/core/framework/default-service.interface';
import { Status } from 'src/app/core/framework/default.model';
import { Duracao, ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { CfgIntegracaoEventoCliente } from '../../model/cfg-integracao-evento-cliente.model';
import { CfgIntegracaoEventoClienteService } from '../evento/service/cfg-integracao-evento-cliente.service';


@Component({
  selector: 'app-popover-editor-url',
  templateUrl: './popover-editor-url.component.html',
  styleUrls: ['./popover-editor-url.component.css']
})
export class PopoverEditorUrlComponent implements OnInit {

  @ViewChild('op') public op: OverlayPanel;
  @Output('atualizarParentEventEmitter') atualizarParentEventEmitter = new EventEmitter();

  public urlAntiga: string;
  public urlNova: string;

  constructor(
    private cfgIntegracaoEventoClienteService: CfgIntegracaoEventoClienteService
    , private toasterService: ToasterService
    , private confirmacaoService: ConfirmacaoService
  ) { }

  ngOnInit(): void {
  }

  show(event: any, target?: any): void {
    this.op.show(event, target);
  }

  hide(): void {
    this.op.hide();
  }

  cancelar(): void {
    this.hide();
  }

  public salvar(): void {
    if ( !this.urlAntiga || !StringUtil.validarUrl(this.urlNova) ) {
      this.toasterService.warning('Favor verificar as URLs informadas');
      return;
    }

    this.confirmacaoService
        .confirmarAtualizacao(() => {
          this.salvarIml();
        });
  }

  private salvarIml(): void {
    let quantidadeUrlsComMatch = 0;
    let quantidadeUrlsSemMatch = 0;

    const filter: DefaultFilter = {status: ''};
    this.cfgIntegracaoEventoClienteService
        .listar(filter)
        .pipe(
          map((result: ListaResultset<CfgIntegracaoEventoCliente>) => {
            const ciecs: CfgIntegracaoEventoCliente[] = result.content;
            ciecs.forEach(ciec => {
              const url = ciec.url;
  
              if ( url.startsWith(this.urlAntiga) ) {
                quantidadeUrlsComMatch++;

                ciec.url = url.replace(this.urlAntiga, this.urlNova);
                this.cfgIntegracaoEventoClienteService
                    .criarOuAtualizar(ciec)
                    .subscribe();
              }
              else {
                quantidadeUrlsSemMatch++;
              }
            });

            if ( quantidadeUrlsComMatch === 0 ) {
              this.toasterService.warning('Com base na URL antiga informada, nenhuma URL foi encontrada.')
            }
            else {
              let msg = 'Quantidade de URLs encontradas e atualizadas: ' + quantidadeUrlsComMatch;
                  msg += '\nQuantidade de URLs não encontradas: ' + quantidadeUrlsSemMatch;

              this.toasterService
                  .info('Operação realizada', msg, Duracao.MEDIO);
            }
          })
        )
        .subscribe(() => {
          this.atualizarParentEventEmitter.emit();
          this.hide();
        });

        
  }

}
